module.exports = __webpack_public_path__ + "img/0-69.29abff99.jpg";